import { fromTable } from "../utils/tables";
import { firstNames, lastNames } from "../tables";

export const getName = ({ formatMessage }) => {
  const firstName = formatMessage(fromTable(firstNames).name);
  const lastName = formatMessage(fromTable(lastNames).name);
  return `${firstName} ${lastName}`;
};
